import { baseApi } from './baseApi'

export type FactoryBaoLocCell = string | number | boolean | null

export interface FactoryBaoLocDateRange {
  startDate: string
  endDate: string
}

export interface FactoryBaoLocContext {
  title: string
  storeChar: string
  factoryCode: string
  viewPrefix: string
  dateRange: FactoryBaoLocDateRange
  permissions: {
    canView: boolean
    canEdit: boolean
    canExport: boolean
  }
}

export interface FactoryBaoLocListResponse {
  items: Array<Record<string, FactoryBaoLocCell>>
  total: number
  source?: string
}

export interface FactoryBaoLocListArgs extends FactoryBaoLocDateRange {
  tab: string
  dataset?: string
}

export const factoryBaoLocApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFactoryBaoLocContext: builder.query<FactoryBaoLocContext, void>({
      query: () => '/factories/bao-loc/context',
      providesTags: ['FactoryBaoLoc'],
    }),
    getFactoryBaoLocTabRows: builder.query<FactoryBaoLocListResponse, FactoryBaoLocListArgs>({
      query: ({ tab, startDate, endDate, dataset }) => {
        const params = new URLSearchParams({ start_date: startDate, end_date: endDate })
        if (dataset) params.set('dataset', dataset)
        return `/factories/bao-loc/${tab}?${params.toString()}`
      },
      providesTags: (_result, _error, args) => [{ type: 'FactoryBaoLoc', id: args.tab }],
    }),
    saveFactoryBaoLocDateRange: builder.mutation<FactoryBaoLocContext, FactoryBaoLocDateRange>({
      query: (body) => ({
        url: '/factories/bao-loc/filters/date-range',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['FactoryBaoLoc'],
    }),
  }),
})

export const {
  useGetFactoryBaoLocContextQuery,
  useGetFactoryBaoLocTabRowsQuery,
  useSaveFactoryBaoLocDateRangeMutation,
} = factoryBaoLocApi
